import { createContext, useContext } from 'react'

import { GridRowActionItem } from '../models/GridRowActions'

export type RowActionsContextType = {
  hotAction?: GridRowActionItem
}

export const RowActionsContext = createContext<RowActionsContextType>({
})

// Used to access context state
export const useRowActionsContext = () => {
  const context = useContext(RowActionsContext)

  if (context === undefined) {
    throw new Error(
      'useRowActionsContext must be used within a RowActionsContext.Provider',
    )
  }

  return context
}
